<template>
  <div class="schoolMember">
    <div class="headView">
      <span class="text">
        如何收徒？邀请新用户（非橙旭园注册用户）加入，即可收徒，并各得1000蓝钻，快去邀请你的朋友一起学习编程吧~
        <!-- <span v-if="school.is_founder">(你是学校CEO，点击头像给员工发工资)</span> -->
      </span>
      <template>
        <div class="btns">
          <span
            class="btn"
            v-if="school && school.is_member && school.is_founder"
            @click="btnEvent('delete')"
          >解散学校</span>
          <span
            class="btn"
            v-if="school && school.is_member && !school.is_founder"
            @click="btnEvent('quit')"
          >退出学校</span>
          <span class="btn" v-if="school && !school.is_member" @click="btnEvent('join')">加入学校</span>
        </div>
      </template>
    </div>
    <div class="members">
      <div
        :class="`member ${item.position === 'master'?'ceo':''}`"
        v-for="item in data"
        :key="item.id"
      >
        <img class="avatar" :src="getImg(item.owner.avatar)" alt/>
        <!-- 成员名和职位 -->
        <div class="content">
          <span class="name">{{item.owner.name}}</span>
          <span class="introduce">{{item.showwork_count}}个作业</span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
// @ is an alias to /src
import { Utils } from "@/utils";

import { types as LoginTypes } from "@/store/modules/login";
import { types as ToastTypes } from "@/store/modules/toast";
import { types as ConfirmTypes } from "@/store/modules/confirm";
import { types as SchoolTypes } from "@/store/modules/school";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "SchoolMember",
  components: {
  },
  props: {},
  data() {
    return {
      school_id: 0,
      show_shadow_view: false, //加蓝钻的
      show_shadow_dialog: false, //改变职位的
      introduce: "",
      currentMember: null,
      number: "0"
    };
  },
  watch: {},
  computed: {
    ...mapState({
      total_count: state => state.school.member.total_count,
      page: state => state.school.member.page,
      load_more: state => state.school.member.load_more,
      data: state => state.school.member.data,
      school: state => state.school.currentSchool
    })
  },
  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW,
      showConfirm: ConfirmTypes.SHOW,
      hideConfirm: ConfirmTypes.HIDE
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchListMember: SchoolTypes.FETCH_MEMBER_LIST,
      fetchJoinSchool: SchoolTypes.FETCH_JOIN_SCHOOL,
      fetchQuitSchool: SchoolTypes.FETCH_QUIT_SCHOOL,
      fetchDeleteSchool: SchoolTypes.FETCH_DELETE_SCHOOL,
    }),
    ...Utils,

    //关闭改变职位dialog框
    hideShadowDialog() {
      this.show_shadow_dialog = false;
    },
    jumpUpdate(item) {
      //如果是ceo则打开修改职位的dialog框
      if (item.position !== "ceo") {
        if (item.is_ceo) {
          this.show_shadow_dialog = true;
          this.currentMember = item;
        }
      }
    },
    //改变职位的提交事件
    submitIntroduce() {
      let job = this.introduce;
      if (this.currentMember) {
        let data = {
          pk: this.currentMember.pk,
          free_job: job
        };
        this.fetchUpdateJob(data);
        this.hideShadowDialog();
      }
    },

    // -----ceo给员工加钻石shadow 事件
    showShadowView(item) {
      this.show_shadow_view = true;
      this.currentMember = item;
    },
    hideShadowView() {
      this.show_shadow_view = false;
    },
    inputEvent() {
      let value = this.number;
      if (value.length === 1) {
        value = value.replace(/[^1-9]/g, "");
      } else {
        value = value.replace(/\D/g, "");
      }
      this.number = value;
    },
    diamondEvent(tag) {
      let number = this.number;
      if (number === "") {
        number = 0;
      }
      number = parseInt(number);

      if (tag === "add") {
        number += 100;
      } else if (tag === "subtract") {
        number -= 100;
      }
      if (number < 0) {
        number = 0;
      }
      this.number = String(number);
    },
    submitEvent() {
      let number = this.number;
      if (number === "" || parseInt(number) < 0) {
        this.showToast({ message: "请输入大于0的数字" });
        return;
      }
      number = parseInt(number);

      if (this.currentMember) {
        let data = {
          diamond: number,
          school_id: this.currentMember.school,
          member_id: this.currentMember.pk
        };
        this.fetchPayMember(data);
        this.hideShadowView();
      }
    },

    btnEvent(tag) {
      let callback = () => {
      if (tag === "join") {
        // 加入学校
        this.fetchJoinSchool({ pk: this.school_id });
      } else if (tag === "quit") {
        // 离开学校
        this.fetchQuitSchool({ pk: this.school_id });
      } else if (tag === "invite") {
        // 邀请好友
        this.$refs.schoolPoster.show(this.school_id);
      } else if (tag === "delete") {
        // 解散学校
        var dic = {
          content: "是否确定解散学校",
          submitCB: () => {
            // console.log("点了确定");
            this.fetchDeleteSchool({ pk: this.school_id });
            this.hideConfirm();
          },
          cancelCB: () => {
            // console.log("点了取消");
            this.hideConfirm();
          },
          submitText: "确定",
          cancelText: "取消"
        };
        this.showConfirm(dic);
      }
      }

      this.dependLoginStatus().then(callback)
    },
    //跳到个人主页
    jumpToProfile(item) {
      if (item.is_ceo) {
        // CEO 的话，打开钻石视图
        this.showShadowView(item);
      } else {
        // 否则，跳到个人主页
        let user_id = item.owner.user_id;
        this.$router.push(`/profile/${user_id}`);
      }
    },
    handleScroll(e) {
      var that = this;
      let height = document.body.clientHeight;
      let scrollHeight = document.body.scrollHeight;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // if(e && e.target){
      //   height = e.target.offsetHeight
      //   scrollHeight = e.target.scrollHeight
      //   scrollTop = e.target.scrollTop
      // }

      // console.log("帖子列表:", height, scrollHeight, scrollTop);
      if (scrollHeight <= height + scrollTop + 20) {
        if (that.load_more) {
          // console.log("还有更多数据，到达底部，继续加载新数据(帖子)");
          that.fetchListMember({
            page: that.page + 1,
            school: that.school_id
          });
        } else {
          // console.log("没有新数据了");
        }
      } else {
        // console.log("没到底部");
      }
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted() {
    let school_id = this.$route.params.school_id;
    this.school_id = school_id;
    this.fetchListMember({ page: 1, school: school_id });
  }
};
</script>

<style lang="less" scoped>
.schoolMember {
  background-color: #f6f6f6;
  padding: 15px;
  min-height: 350px;
  .headView {
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .text {
      color: #6B45E1;
      font-size: 13px;
    }
    .btns {
      display: flex;
      flex-direction: row;
    }
    .btn {
      padding: 3px 10px;
      border-radius: 15px;
      color: #ffffff;
      font-size: 13px;
      background-color: #5024fe;
      cursor: pointer;
      margin-left: 15px;
    }
  }
  .members {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: calc(100%);
    margin: auto;
    margin-left: 5px;
    .member {
      background-color: #ffffff;
      border: 1px solid rgba(245, 101, 1, 0.45);
      margin-right: 10px;
      margin-bottom: 10px;
      padding: 10px;
      border-radius: 8px;
      overflow: hidden;
      width: 170px;
      width: calc(100% / 4 - 12px - 20px);
      display: flex;
      flex-direction: row;
      align-items: center;
      position: relative;
      color: #333333;
      .content {
        display: flex;
        flex-direction: column;
        // width: 44px;
        height: 44px;
        font-size: 16px;
        .ceo {
          color: rgba(245, 101, 1, 1);
          width: 35px;
          font-family: PingFang SC;
          font-weight: bold;
        }
      }
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 15px;
        display: inline-block;
        // cursor: pointer;
      }
      .name {
        flex: 1;
        font-size: 16px;
        height: 20px;
        overflow: hidden;
        line-height: 20px;
      }
      .introduce {
        opacity: 0.5;
        // cursor: pointer;
      }
      .position {
        position: absolute;
        right: 0;
        top: 0;
        padding: 1px 2px;
        background-color: #f56501;
        color: #ffffff;
        font-size: 12px;
        &.ceo {
          background-color: #ffee00;
          color: #333333;
        }
      }
    }
  }
}
//ceo给员工发钻石的弹出框
.addDiamondShadow {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .addDiamondView {
    width: 50%;
    border-radius: 5px;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top: 0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
    .addDiamondWrapper {
      background-color: #ffffff;
      .header {
        height: 35px;
        line-height: 35px;
        background-color: #6b45e1;
        width: 100%;
        font-size: 16px;
        color: #ffffff;
        display: block;
        text-align: center;
      }
      .counterView {
        margin-bottom: 20px;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        color: #6b45e1;
        font-size: 40px;
        .add {
          cursor: pointer;
        }
        .input {
          border: solid 1px #6b45e1;
          margin: 0 20px;
          height: 30px;
          display: flex;
          padding: 0 5px;
          border-radius: 5px !important;
          input {
            border: none;
            width: 100%;
            height: 100%;
          }
        }
        .subtract {
          cursor: pointer;
        }
      }
      .submit {
        border-radius: 15px;
        font-size: 14px;
        color: #ffffff;
        background-color: #6b45e1;
        display: inline-block;
        margin-bottom: 20px;
        width: 70px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin-left: calc(50% - 24px);
        cursor: pointer;
      }
    }
  }
}

//修改职位的弹出框
.updateIntroduceShadow {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .addUpdateView {
    width: 30%;
    border-radius: 5px;
    position: relative;
    .close {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #ffffff;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: absolute;
      right: -50px;
      top: 0;
      transform: rotate(45deg);
      .line1 {
        position: absolute;
        width: 20px;
        height: 1.5px;
        background-color: #644ed9;
        top: calc(50% - 1px);
      }
      .line2 {
        width: 1.5px;
        height: 20px;
        background-color: #644ed9;
      }
    }
    .addUpdateWrapper {
      background-color: #fff;
      border-radius: 10px;
      .header {
        height: 50px;
        line-height: 50px;
        background-color: #6b45e1;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        width: 100%;
        font-size: 16px;
        color: #ffffff;
        display: block;
        text-align: center;
      }
      .introduceContent {
        margin-bottom: 20px;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #6b45e1;
        font-size: 40px;
        .input {
          border: solid 1px #6b45e1;
          margin: 0 20px;
          height: 30px;
          display: flex;
          padding: 0 5px;
          width: 300px;
          border-radius: 5px !important;
          input {
            border: none;
            width: 100%;
            height: 100%;
          }
        }
        .submit {
          border-radius: 15px;
          font-size: 14px;
          color: #ffffff;
          background-color: #6b45e1;
          display: inline-block;
          margin-bottom: 20px;
          width: 70px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
